import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=7dd79981&scoped=true"
import script from "./FooterSocial.vue?vue&type=script&lang=js"
export * from "./FooterSocial.vue?vue&type=script&lang=js"
import style0 from "./FooterSocial.vue?vue&type=style&index=0&id=7dd79981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd79981",
  null
  
)

export default component.exports